import { inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SwUpdate } from '@angular/service-worker';

import * as Sentry from '@sentry/angular';
import { BehaviorSubject, filter, interval, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NewVersionCheckerService {
  readonly #swUpdate = inject(SwUpdate);
  isNewVersionAvailable = new BehaviorSubject<boolean>(false);

  updateInterval = 15 * 60 * 1000;

  constructor() {
    if (!this.#swUpdate.isEnabled) {
      return;
    }

    this.#promptOnUpdateAvailable();
    this.#checkForUpdateAfterInterval(this.updateInterval);
  }

  applyUpdate(): void {
    this.#swUpdate.activateUpdate().then(() => globalThis.location.reload());
  }

  #promptOnUpdateAvailable(): void {
    this.#swUpdate.versionUpdates
      .pipe(
        takeUntilDestroyed(),
        filter(event => event.type === 'VERSION_READY'),
        tap(() => Sentry.captureMessage('New Version Was Deployed')),
      )
      .subscribe(() => this.isNewVersionAvailable.next(true));
  }

  #checkForUpdateAfterInterval(updateInterval: number) {
    this.#swUpdate.checkForUpdate();

    interval(updateInterval).subscribe(() => {
      this.#swUpdate.checkForUpdate();
    });
  }
}
